import { appConfig } from "../app.config";

export const getUserProfileUrl = appConfig.baseUrl + "/auth/user/profile";
export const updateUserProfileUrl = appConfig.baseUrl + "/auth/update/user/profile/oauth2/cdd";
export const updateUserProfilePictureUrl = appConfig.baseUrl + "/auth/update/user/profile/picture/oauth2/cdd";
export const getUserProfilePictureUrl = appConfig.baseUrl + "/auth/user/profile/picture/oauth2/cdd";